module.exports = __webpack_public_path__ + "img/坚如磐石的数据安全@2x.77a46325.png";